import React, { useState } from 'react';
import InfoBubble from '@gp/components/InfoBubble';
import TextAreaMore from '@gp/components/TextAreaMore';

import type { IBaseProps } from '@home/types/common';

export interface IEllipsisTextBubbleProps extends IBaseProps {
  bubbleClassName?: string;
  bubbleStyle?: React.CSSProperties;
  text: string;
  isShowAllContent?: boolean;
  ellipsisLineClamp?: number;
  customBubbleContent?: any;
  // 是否展示固定格式气泡内容
  isVisibleFixedCustomBubble?: boolean;
  textElClassName?: string;
  lineHeight?: number;
  onTextClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
}

const EllipsisTextBubble: React.FC<IEllipsisTextBubbleProps> = (props) => {

  const {
    className = '',
    style = {},
    bubbleClassName = '',
    bubbleStyle = {},
    text = '',
    isShowAllContent,
    ellipsisLineClamp = 1,
    customBubbleContent = null,
    isVisibleFixedCustomBubble = false,
    textElClassName,
    lineHeight,
    onTextClick,
    ...restProps
  } = props;

  const [visible, setVisible] = useState<boolean>(false);

  const getCustomBubbleContent = () => {
    if (isVisibleFixedCustomBubble) return customBubbleContent;
    if (visible) return customBubbleContent || text;
    return void 0;
  };

  return (
    <InfoBubble
      {...restProps}
      className={`globalpedia-modal-font14 ${bubbleClassName}`}
      style={Object?.assign({width: '100%'}, bubbleStyle)}
      customBubbleContent={getCustomBubbleContent()}
      DomOrText={(
        <TextAreaMore
          className={className}
          textElClassName={textElClassName}
          customStyle={style}
          type="ellipsis"
          isMustNoButton
          text={text}
          isShowAllContent={isShowAllContent}
          ellipsisLineClamp={ellipsisLineClamp}
          getIsFold={setVisible}
          lineHeight={lineHeight}
          onTextClick={onTextClick}
        />
      )}
    />
  );
};

export default React.memo(EllipsisTextBubble);
